import React, { FC } from 'react';
import { Modal } from 'antd';

interface ImageModalProps {
  imageUrl: string;
  isModalVisible: boolean;
  hideModal: () => void;
}

export const ImageModal: FC<ImageModalProps> = ({ imageUrl, isModalVisible, hideModal }) => {
  return (
    <Modal
      open={isModalVisible}
      width={900}
      centered
      onCancel={hideModal}
      footer={null}
      closable={false}
    >
      <button
        onClick={hideModal}
        className="absolute -top-5 -right-5 w-12 h-12 flex items-center justify-center font-bold shadow-lg bg-gray-300 rounded-full text-gray-700 hover:bg-gray-400 hover:text-black text-3xl leading-none"
      >
        <span className="relative -top-[3px]">&times;</span>
      </button>
      <img className="rounded-xl w-full" src={imageUrl} alt="Image" />
    </Modal>
  );
};
